import { ReactNode, useCallback } from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";

interface MobileCardProps {
  children: ReactNode;
  onClick?: () => void;
  /** Flat list-item mode: no border/radius, just a bottom divider. */
  flat?: boolean;
  sx?: SxProps<Theme>;
}

export default function MobileCard({ children, onClick, flat = false, sx }: MobileCardProps) {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (onClick && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        onClick();
      }
    },
    [onClick],
  );

  return (
    <Box
      onClick={onClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={[
        {
          backgroundColor: "#fff",
          borderRadius: flat ? 0 : "8px",
          padding: "4px 10px 8px",
          border: flat ? "none" : "1px solid #ccc",
          borderBottom: flat ? "1px solid #E8E8E8" : "1px solid #ccc",
          cursor: onClick ? "pointer" : "default",
          transition: "background-color 0.15s",
          "&:active": onClick ? { backgroundColor: "#F5F5F5" } : undefined,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}
